import { dispatchSnackbarNegativeEvent, RouteLeavingGuard } from '@dreryk/react-components';
import { useDraftCreateCqrsCommand } from '@dreryk/react-draft';

import { visitTranslationKeys } from '../../../translations';
import { getDocumentTemplateDraftTag, getVisitDraftTag } from '../../../visit/visit.draft';
import { getReferralDraftToken } from '../referral.draft';
import { referralTranslationKeys } from '../translations';

import { ReferralToPsychiatricHospitalFormController } from './ReferralToPsychiatricHospitalForm/referralToPsychiatricHospitalForm.types';

type ReferralToPsychiatricHospitalRouteLeavingGuardProps = {
   readonly visitId: number;
   readonly formState: ReferralToPsychiatricHospitalFormController['formState'];
   readonly handleSubmitDraft: ReferralToPsychiatricHospitalFormController['handleSubmitDraft'];
};

const defaultDraftPersonEnteredByUser = {
   firstName: null,
   lastName: null,
};
const defaultDraftPersonAddress = {
   town: null,
   building: null,
   postcode: null,
   country: null,
   street: null,
   flat: null,
};

export const ReferralToPsychiatricHospitalRouteLeavingGuard = (
   props: ReferralToPsychiatricHospitalRouteLeavingGuardProps
): JSX.Element => {
   const { executeAsync: saveReferralToPsychiatricHospitalDraft } = useDraftCreateCqrsCommand({
      onUnexpectedError: () => {
         dispatchSnackbarNegativeEvent(visitTranslationKeys.draftSaveFail);
      },
   });

   return (
      <RouteLeavingGuard
         testId={'referralToPsychiatric'}
         active={props.formState.isDirty}
         onLeave={props.handleSubmitDraft(async (values) =>
            saveReferralToPsychiatricHospitalDraft({
               token: getReferralDraftToken('referralToPsychiatricHospital', props.visitId),
               tags: [getVisitDraftTag(props.visitId), getDocumentTemplateDraftTag(props.visitId)],
               contents: {
                  ...values,
                  actualGuardianEnteredByUser: values.actualGuardianEnteredByUser ?? defaultDraftPersonEnteredByUser,
                  statutoryRepresentativeEnteredByUser:
                     values.statutoryRepresentativeEnteredByUser ?? defaultDraftPersonEnteredByUser,
                  statutoryRepresentativeAddress: values.statutoryRepresentativeAddress ?? defaultDraftPersonAddress,
                  actualGuardianAddress: values.actualGuardianAddress ?? defaultDraftPersonAddress,
               },
            })
         )}
         successMessage={referralTranslationKeys.referralDraftSaved}
      />
   );
};
